import { render, staticRenderFns } from "./CadastroFormularios.vue?vue&type=template&id=b4e44da0&scoped=true"
import script from "./CadastroFormularios.vue?vue&type=script&lang=js"
export * from "./CadastroFormularios.vue?vue&type=script&lang=js"
import style0 from "./CadastroFormularios.vue?vue&type=style&index=0&id=b4e44da0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4e44da0",
  null
  
)

export default component.exports